import React from 'react';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
function Selector(props) {

  var onWindowNumberChange = function (range) {
    props.onWindowNumberChange(range.target.value)
  }

  return (
    <>
      <SelectorFrequency frequency={props.frequency} onFrequencyChange={props.onFrequencyChange}></SelectorFrequency>
      <TypeSelector type={props.type} onChangeType={props.setType}/>
      <Form.Control plaintext readOnly value={'Number of windows: ' + props.numberOfWindows} />
      <Form.Range value={props.numberOfWindows} min='1' max='10' onChange={onWindowNumberChange}></Form.Range>
    </>
  );

}

function SelectorFrequency(props) {
  var changeFrequency = function (frequency) {
    props.onFrequencyChange(frequency)
  }
  return (<Dropdown>
    <Dropdown.Toggle variant="success" id="dropdown-basic">
      {props.frequency}
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item name="DAY" onClick={changeFrequency}>Day</Dropdown.Item>
      <Dropdown.Item name="WEEK" onClick={changeFrequency}>Week</Dropdown.Item>
      <Dropdown.Item name="MONTH" onClick={changeFrequency}>Month</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>)
}

function TypeSelector(props) {
  var changeType = function (type) {
    props.onChangeType(type.target.name)
  }
  return (<Dropdown>
    <Dropdown.Toggle variant="success" id="dropdown-basic">
      {props.type}
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item name="organizer" onClick={changeType}>Organizer</Dropdown.Item>
      <Dropdown.Item name="learning" onClick={changeType}>Learning</Dropdown.Item>
      <Dropdown.Item name="screen_time" onClick={changeType}>Screen Time</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>)
}
export default Selector;